// frontend/src/notifications/NotificationsContext.jsx
import { createContext, useContext } from 'react'
import { useNotifications } from './useNotifications'
import { usePresence } from './usePresence'
import { usePushSubscription } from './usePushSubscription'

const Ctx = createContext(null)

export function NotificationsProvider({ children }) {
  usePresence()
  usePushSubscription()
  const value = useNotifications()
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useNotificationsContext() {
  const v = useContext(Ctx)
  if (!v) throw new Error('useNotificationsContext must be inside NotificationsProvider')
  return v
}
